if (!customElements.get('ksh-gallery')) {
  customElements.define('ksh-gallery', class extends HTMLElement {
    connectedCallback() {
      if(this.initialized) return;
      this.initialized=true;
      const track=this.querySelector('.ksh-gallery-track');
      const slides=[...this.querySelectorAll('.ksh-gallery-slide')];
      const thumbs=[...this.querySelectorAll('[data-index]')];
      if(!slides.length) return;
      let current=0;
      const go=index=>track.scrollTo({left:slides[Math.max(0,Math.min(index,slides.length-1))].offsetLeft-slides[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      const update=()=>{
        current=Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/track.clientWidth)));
        thumbs.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===current)));
        const counter=this.querySelector('[data-counter]');
        if(counter) counter.textContent=`${current+1} / ${slides.length}`;
        const prev=this.querySelector('[data-prev]'),next=this.querySelector('[data-next]');
        if(prev) prev.disabled=current===0;
        if(next) next.disabled=current===slides.length-1;
      };
      this.querySelectorAll('[hidden]').forEach(el=>el.hidden=false);
      this.querySelector('[data-prev]')?.addEventListener('click',()=>go(current-1));
      this.querySelector('[data-next]')?.addEventListener('click',()=>go(current+1));
      thumbs.forEach((button,i)=>button.addEventListener('click',()=>go(i)));
      track.addEventListener('scroll',update,{passive:true});
      track.addEventListener('keydown',event=>{if(['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();go(current+(event.key==='ArrowRight'?1:-1));}});
      const dialog=this.querySelector('dialog');
      let startX=0,startY=0;
      track.addEventListener('pointerdown',event=>{startX=event.clientX;startY=event.clientY;},{passive:true});
      slides.forEach(slide=>slide.addEventListener('click',event=>{
        if(event.ctrlKey||event.metaKey||event.shiftKey||event.altKey) return;
        event.preventDefault();
        if(event.detail && (Math.abs(event.clientX-startX)>12||Math.abs(event.clientY-startY)>12)) return;
        const img=dialog.querySelector('img');img.src=slide.href;img.alt=slide.querySelector('img').alt;dialog.showModal();
      }));
      this.querySelector('[data-close]').addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
      this.addEventListener('ksh:variant-image',event=>{const index=slides.findIndex(slide=>slide.dataset.imageId===String(event.detail));if(index>=0)go(index);});
      update();
    }
  });
}
function initKshForms(root=document){
  root.querySelectorAll('[data-ksh-form]').forEach(form=>{
    if(form.dataset.initialized) return;form.dataset.initialized='true';
    const select=form.querySelector('select[name=id]');
    if(!select) return;
    select.addEventListener('change',()=>{
      const option=select.selectedOptions[0],available=option.dataset.available==='true';
      const button=form.querySelector('[type=submit]');button.disabled=!available;button.textContent=available?form.dataset.add:form.dataset.sold;
      const section=form.closest('.ks-pdp');section.querySelector('.ks-price').textContent=option.dataset.price;
      const stock=section.querySelector('[data-ksh-stock]');if(stock)stock.textContent=available?form.dataset.available:form.dataset.sold;
      section.querySelector('ksh-gallery')?.dispatchEvent(new CustomEvent('ksh:variant-image',{detail:option.dataset.image}));
      const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);
    });
  });
}
initKshForms();
document.addEventListener('shopify:section:load',event=>initKshForms(event.target));
